module.exports = __webpack_public_path__ + "img/G_Art_Claw_R_1_2_1.6a6770c5.png";